var isLeapYear=require('../is_leap_year/index.js');/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */function getDaysInYear(dirtyDate){return isLeapYear(dirtyDate)?366:365;}module.exports=getDaysInYear;